import LoginComponent from './LoginComponent/LoginComponent';
import SignUpComponent from './SignUpComponent/SignUpComponent';
import ForgotPasswordComponent from './ForgotPasswordComponent/ForgotPasswordComponent';
import ForgotUsernameComponent from './ForgotUsernameComponent/ForgotUsernameComponentExt';
import ResetPasswordComponent from './ResetPasswordComponent/ResetPasswordComponent';

const LoginCapabilityComponentMap = {
    LoginComponent: { component: 'LoginComponent' },
    SignUpComponent: { component: 'SignUpComponent' },
    ForgotPasswordComponent: { component: 'ForgotPasswordComponent' },
    ForgotUsernameComponent: { component: 'ForgotUsernameComponent' },
    ResetPasswordComponent: { component: 'ResetPasswordComponent' }
};

const LoginCapabilityComponents = {
    LoginComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    ForgotUsernameComponent,
    ResetPasswordComponent
};

export {
    LoginCapabilityComponentMap,
    LoginCapabilityComponents,
    LoginComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    ForgotUsernameComponent,
    ResetPasswordComponent
};
